class Service {
    deviceType= "service";
    code= "Serviço";
    description= "Serviço";
    manufacturer= "";
   
    unit = "pacote";
    product = { 
      price:0,
      cost:0,
      // taxes:0,
      sellerId:"", //Now its a string
      available:true, //editted by the user
       unit : "pacote",
      quantity:0

   };

    constructor() {
    };
   


    calc(){
   
    }

    //calular inversor
}




export default Service;
